<template>
	<BuyersOrderGroup name="First Payment">
		<template #column-1>
			<InputCurrency
				:saturn="bo.finalNumbers.leaseFinalNumbers.firstPaymentWithTax"
				:disabled="true"
				:precision="2"
				iconSide="left"
				:negative="true"
			>
			</InputCurrency>
		</template>

		<template #children>
			<BuyersOrderRow
				class="buyers-order-row"
				:style="$grid('25px-1-30px-115px-125px-125px', '0px 5px')"
			>
				<template #left-icon>
					<span class="buyers-order-upfront-capped-icon">
						<Pill
							label="U"
							status="success"
							:size="10"
							:includeDot="false"
						/>
					</span>
				</template>

				<template #info>
					<span>Base Monthly Payment</span>
				</template>

				<template #column-1>
					<InputCurrency
						:saturn="bo.finalNumbers.monthlyPayment"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true"
					>
					</InputCurrency>
				</template>
			</BuyersOrderRow>

			<BuyersOrderRow
				v-for="monthlyUseItem in bo.finalNumbers.leaseFinalNumbers.monthlyUseTaxInfo"
				:key="monthlyUseItem.taxLineName"
			>
				<template #left-icon>
					<span class="buyers-order-upfront-capped-icon">
						<Pill
							label="U"
							status="success"
							:size="10"
							:includeDot="false"
						/>
					</span>
				</template>

				<template #info>
					<span> Monthly Use {{ monthlyUseItem.taxLineName }} ({{ monthlyUseItem.taxLineRate.toFixed(2) }}%) </span>
				</template>

				<template #column-1>
					<InputCurrency
						:saturn="monthlyUseItem.taxLineMonthlyTaxAmount"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true"
					>
					</InputCurrency>
				</template>

				<!-- Do we need this? -->
				<!-- <template #column-2>
					<InputCurrency
						:saturn="monthlyUseItem.taxLineTotalTaxAmount"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true">
					</InputCurrency>
				</template> -->
			</BuyersOrderRow>
		</template>
	</BuyersOrderGroup>
</template>

<script setup lang="ts">
	import BuyersOrderGroup from './BuyersOrderGroup.vue';
	import BuyersOrderRow from './BuyersOrderRow.vue';
	import FIMenuBuyersOrder from '@core/classes/FIMenuBuyersOrder';
	import InputCurrency from '@core/components/InputCurrency.vue';
	import Pill from '@core/components/Pill.vue';

	interface IBuyersOrderFirstPaymentProps {
		bo: FIMenuBuyersOrder;
	}

	const { bo } = defineProps<IBuyersOrderFirstPaymentProps>();
</script>

<style scoped></style>
